import { gql } from "graphql-tag"

const eightLeggedFreak = gql`
  type Mutation {
    eightLeggedFreakNewsSourcesGather(
      eightLeggedFreakNewsSourcesGatherInput: EightLeggedFreakNewsSourcesGatherInput!
    ): EightLeggedFreakNewsSourcesGather

    eightLeggedFreakNewsSourceUpdate(
      eightLeggedFreakNewsSourceUpdateInput: EightLeggedFreakNewsSourceUpdateInput!
      serviceName: String!
    ): EightLeggedFreakNewsSourceResponse

    eightLeggedFreakGather(
      eightLeggedFreakGatherInput: EightLeggedFreakGatherInput!
    ): EightLeggedFreakGather

    eightLeggedFreakReviewUpdate(
      eightLeggedFreakReviewUpdateInput: EightLeggedFreakReviewUpdateInput!
      serviceName: String!
    ): EightLeggedFreakReviewResponse
  }
`

export default eightLeggedFreak
